import { em } from 'polished'
import styled, { css } from 'styled-components'

import { BoxBase } from 'styles/components/layout'

export const BoxBaseStyled = styled(BoxBase)`
  min-height: ${em(360)};

  ${p => p.theme.mq.upMd} {
    min-height: ${em(596)};
  }
`

const hidden = css`
  opacity: 0;
  transform: translateY(${em(30)});
  transition-property: opacity, transform;
  transition-duration: 600ms;
  transition-timing-function: ease-out;
`

export const TextWrapper = styled.div`
  max-width: ${em(280)};
  display: inline-block;
  color: ${p => p.theme.colors.white};
  text-align: center;

  ${p => p.theme.mq.upMd} {
    max-width: ${em(450)};
    ${hidden};

    ${({ isVisible }) =>
      isVisible &&
      css`
        opacity: 1;
        transform: translateY(0);
      `}
  }
`

export const Num = styled.div`
  font-size: ${em(138)};
  line-height: 1;
  padding-bottom: ${em(10, 138)};

  ${p => p.theme.mq.upMd} {
    font-size: ${em(238)};
    line-height: 0.823529412;
    padding-bottom: ${em(18, 238)};
  }
`

export const NumWrapper = styled.div`
  display: flex;
  justify-content: center;
  color: ${p => p.theme.colors.white};

  ${p => p.theme.mq.upMd} {
    ${hidden};

    ${({ isVisible }) =>
      isVisible &&
      css`
        opacity: 1;
        transform: translateY(0);
      `}
  }
`

export const IconWrapper = styled.div`
  width: ${em(89)};
  height: ${em(89)};
  align-self: center;
  margin-left: ${em(20)};

  ${p => p.theme.mq.upMd} {
    width: ${em(155)};
    height: ${em(155)};
  }
`
